import { render, staticRenderFns } from "./AddORDisableCustodian.vue?vue&type=template&id=494f3575&"
import script from "./AddORDisableCustodian.vue?vue&type=script&lang=js&"
export * from "./AddORDisableCustodian.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports